import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { ROUTES } from '../../sidebar/sidebar.component';
import { Location } from '@angular/common';
import { AuthenticationService } from '../../authentication/authentication.service'
import { ProfileService } from 'src/app/profile/profile.service';
import { NotificationBuilder } from '../notificationBuilder';

var misc: any = {
    navbar_menu_visible: 0,
    active_collapse: true,
    disabled_collapse_init: 0,
}
declare var $: any;

@Component({
    moduleId: module.id,
    selector: 'navbar-cmp',
    templateUrl: 'navbar.component.html',
    styleUrls: ['./navbar.component.css']
})

export class NavbarComponent implements OnInit {
    private listTitles: any[];
    location: Location;
    private nativeElement: Node;
    private toggleButton;
    private sidebarVisible: boolean;
    public isAdmin: boolean;
    public profilePlan: any

    @ViewChild("navbar-cmp") button;
    showStoreListBtn: boolean;
    storeName: string;
    accountName: string;
    nameInitials: any;

    constructor(location: Location, private renderer: Renderer2, private notificationBuilder: NotificationBuilder, private element: ElementRef, private authenticationService: AuthenticationService, private profileService : ProfileService) {
        this.location = location;
        this.nativeElement = element.nativeElement;
        this.sidebarVisible = false;
    }

    ngOnInit() {
        this.isAdmin = localStorage.getItem("admin-token") != null
        var customization = localStorage.getItem("polenPainelCustomized")
        this.storeName = localStorage.getItem("storeName");

        this.accountName = this.authenticationService.getAccountName();
        this.nameInitials = this.getNameInitials(this.accountName);
        this.showStoreListBtn = this.authenticationService.countTotalStores() > 1

        debugger
        this.profilePlan = this.authenticationService.getProfilePlanInfo();
        if (this.profilePlan == null) {
            this.profileService.GetProfilePlanInfo().subscribe(res => {
                if (res.success) {
                   
                    this.authenticationService.setProfilePlanInfo(res.data);
                    this.profilePlan = res.data;
                    if (this.profilePlan.isBlocked){
                        this.notificationBuilder.showNotification('danger', 50000, "O Polen está encerrando suas atividades. Como sua empresa não está ativa a mais de 3 meses seus dados estão em processo de exclusão respeitando a LGPD.");
                        this.authenticationService.logout();
                        return;
                    }
                }
            })
        }

        if (this.profilePlan != null && this.profilePlan.isBlocked){
            this.notificationBuilder.showNotification('danger', 50000, "O Polen está encerrando suas atividades. Como sua empresa não está ativa a mais de 3 meses seus dados estão em processo de exclusão respeitando a LGPD.");
            this.authenticationService.logout();
            return;
        }

        this.listTitles = ROUTES.filter(listTitle => listTitle);

        var navbar: HTMLElement = this.element.nativeElement;
        this.toggleButton = navbar.getElementsByClassName('navbar-toggle')[0];        
        if ($('body').hasClass('sidebar-mini')) {
            misc.sidebar_mini_active = true;
        }
        $('#minimizeSidebar').click(function () {
            var $btn = $(this);

            if (misc.sidebar_mini_active == true) {
                $('body').removeClass('sidebar-mini');
                misc.sidebar_mini_active = false;

            } else {
                setTimeout(function () {
                    $('body').addClass('sidebar-mini');

                    misc.sidebar_mini_active = true;
                }, 300);
            }

            // we simulate the window Resize so the charts will get updated in realtime.
            var simulateWindowResize = setInterval(function () {
                window.dispatchEvent(new Event('resize'));
            }, 180);

            // we stop the simulation of Window Resize after the animations are completed
            setTimeout(function () {
                clearInterval(simulateWindowResize);
            }, 1000);          
        });
    }
    getNameInitials(name: any): any {
        try{
            let rgx = new RegExp(/(\p{L}{1})\p{L}+/, 'gu');
            let initials = [...name.matchAll(rgx)] || [];
            initials = (
                (initials.shift()?.[1] || '') + (initials.pop()?.[1] || '')
            ).toUpperCase();
    
            console.log(initials);
            return initials;
        }
        catch(e){
            return "PO";
        }        
    }

    desimpersonate() {
        this.authenticationService.Deimpersonate()
    }

    isMobileMenu() {
        if ($(window).width() < 991) {
            return false;
        }
        return true;
    }

    sidebarOpen() {
        var toggleButton = this.toggleButton;
        var body = document.getElementsByTagName('body')[0];
        setTimeout(function () {
            toggleButton.classList.add('toggled');
        }, 500);
        body.classList.add('nav-open');
        this.sidebarVisible = true;
    }
    sidebarClose() {
        var body = document.getElementsByTagName('body')[0];
        this.toggleButton.classList.remove('toggled');
        this.sidebarVisible = false;
        body.classList.remove('nav-open');
    }
    sidebarToggle() {
        // var toggleButton = this.toggleButton;
        // var body = document.getElementsByTagName('body')[0];
        if (this.sidebarVisible == false) {
            this.sidebarOpen();
        } else {
            this.sidebarClose();
        }
    }

    getTitle() {
        var titlee = this.location.prepareExternalUrl(this.location.path());
        if (titlee.charAt(0) === '#') {
            titlee = titlee.slice(2);
        }
        for (var item = 0; item < this.listTitles.length; item++) {
            var parent = this.listTitles[item];
            if (parent.path === "/" + titlee) {
                return parent.title;
            } else if (parent.children) {
                var children_from_url = titlee.split("/")[2];
                for (var current = 0; current < parent.children.length; current++) {
                    if (parent.children[current].path === children_from_url) {
                        return parent.children[current].title;
                    }
                }
            }
        }
        return 'Dashboard';
    }

    getPath() {
        return this.location.prepareExternalUrl(this.location.path());
    }

    showCompanyList() {
        this.authenticationService.logoutFromCompany();
    }

    showStoreList() {
        this.authenticationService.logoutFromStore();
    }

    logout() {
        this.authenticationService.logout()
    }
}
